import en from './en.yaml'
import zh from './zh.yaml'

export const COMPARISON_REPORT_NS = 'comparisonReport'
const translations = { zh, en }

export default translations
